module.exports = __webpack_public_path__ + "img/cheatsheet_icon_recommendations_gold_2x.2944f2ae.png";